module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f1-300x300.3f4ddebd.webp";